!function webpackUniversalModuleDefinition(e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports["@wordpress/dom-ready"] = t() : (e.wp = e.wp || {}, e.wp.domReady = t());
}(self, function () {
  return function () {
    "use strict";

    var e = {};
    return function () {
      var t = e;
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = function domReady(e) {
        if ("undefined" == typeof document) return;
        if ("complete" === document.readyState || "interactive" === document.readyState) return void e();
        document.addEventListener("DOMContentLoaded", e);
      };
    }(), e;
  }();
});